import "./CompanyInformationPageHeaderComponent.scss";
import template from "./CompanyInformationPageHeaderComponent.html";
import {IComponentOptions} from "angular";
import {CodeAndExchange, securityEquality} from "../../../instruments/types/CodeAndExchange";
import {Observable, ReplaySubject} from "rxjs";
import {ComponentCallback} from "../../../types/AngularJS";
import {ObjectUtil} from "../../../js/util/ObjectUtil";
import {QuoteStore} from "../../../quote/store/QuoteStore";
import {CompanyInfo} from "../../../types/Company";
import {QuoteViewModel} from "../../../quote/models/QuoteViewModel";
import {securityQuoteRequest} from "../../../quote/models/QuoteRequest";
import {PortfolioType} from "../../../portfolio/models/Portfolio";
import {CompanyService} from "../../../services/company/CompanyService";
import {isNotNull} from "../../../js/util/UtilFunctions";

export const PageHeader = "tfCompanyInfoPageHeader";

export function pageHeader(): IComponentOptions {
    return {
        template,
        bindings: {
            security: "<",
            onChange: "&"
        },
        controllerAs: "ctrl",
        controller: CompanyInformationPageHeaderComponentController
    };
}

export class CompanyInformationPageHeaderComponentController {

    /** @input */
    public set security(security: CodeAndExchange | null) {
        if (security != null) {
            this.security$.next(security);
        }
    }

    public readonly security$ = new ReplaySubject<CodeAndExchange>(1);

    /** @output */
    public readonly onChange: ComponentCallback;

    public readonly companyName$: Observable<string>;
    public readonly quote$: Observable<QuoteViewModel>;

    /** @ngInject */
    public constructor(private readonly quoteStore: QuoteStore,
                       private readonly companyService: CompanyService) {
        this.companyName$ = this.buildCompanyName();
        this.quote$ = this.buildQuote();
    }

    private buildCompanyName(): Observable<string> {
        return this.security$
                   .distinctUntilChanged(securityEquality())
                   .flatMap((s) => this.findCompany(s))
                   .filter(isNotNull)
                   .map((c) => c.name)
                   .publishReplay(1)
                   .refCount();
    }

    private async findCompany(security: CodeAndExchange): Promise<CompanyInfo | null> {
        const companies = await this.companyService.companies();
        return companies.find((c) => c.code === security.code)!;
    }

    private buildQuote(): Observable<QuoteViewModel> {
        return this.security$
                   .distinctUntilChanged(securityEquality())
                   .map((sec) => securityQuoteRequest(sec, PortfolioType.BROKER))
                   .switchMap((req) => this.quoteStore.stream(req))
                   .publishReplay(1)
                   .refCount();
    }

    public companyChanged(company: CompanyInfo) {
        const security = ObjectUtil.pick(company, "code", "exchange");
        this.onChange({security});
    }
}
